/**
 * @author
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
	async login(ticket, tgtToken) {
		return request(api.base.LOGIN + "?ticket=" + ticket + "&tgtToken=" + tgtToken, METHOD.GET);
	},
	async logout() {
		return request(api.base.LOGOUT, METHOD.POST);
	},

}


export default {dataApi}